export const environment = {
  production: true,
  functions: {
    fillMissingHashes: "https://europe-west3-savo-33b6d.cloudfunctions.net/fillMissingHashes",
    fixAmounts: "https://europe-west3-savo-33b6d.cloudfunctions.net/fixAmounts"
  },
  firebaseConfig: {
    apiKey: "AIzaSyCJ9ZrItY3hwNbDOdCf5qssH986OEdSN18",
    authDomain: "savo-33b6d.firebaseapp.com",
    databaseURL: "https://savo-33b6d.firebaseio.com",
    projectId: "savo-33b6d",
    storageBucket: "savo-33b6d.appspot.com",
    messagingSenderId: "911740523871",
    appId: "1:911740523871:web:5321eafc741aaac12952ea"
  }
};
